import { createFileRoute } from "@tanstack/react-router";
import { SpecialtyDesignSystem } from "@/pages/design-system/SpecialtyDesignSystem";

export const Route = createFileRoute("/demo/design-system/specialty/")({
  component: SpecialtyDesignSystem,
});
